export default {
  birthDate: 'Ημερομηνία γέννησης',
  birthDay: 'ΗΗ',
  birthMonth: 'ΜΜ',
  birthYear: 'ΕΕΕΕ',
  certified: {
    title: 'Πιστοποιημένος χρήστης',
    register: 'Εγγραφή Πιστοποιημένου χρήστη',
    desc:
      'Ο Πιστοποιημένος χρήστης απολαμβάνει το σύνολο των ηλεκτρονικών υπηρεσιών που προσφέρει η ΕΒΕ',
    modal: {
      title: 'Επιβεβαίωση',
      desc:
        'Για την εγγραφή σας ως Πιστοποιημένος χρήστης, παρακαλώ, επιβεβαιώστε, αν έχετε ήδη λογαριασμό ή κάνετε εγγραφή για πρώτη φορά',
      user: {
        registered: 'Έχω ήδη λογαριασμό',
        new: 'Είμαι νέος χρήστης'
      },
      back: 'Επιστροφή'
    },
    taxis: {
      desc:
        'Για την πιστοποίηση των στοιχείων (Όνομα, Επώνυμο, Πατρώνυμο, Ημερομηνία γέννησης) χρειάζεται η διασύνδεση της εφαρμογής με το TAXISnet',
      connect: 'Διασύνδεση με TAXISnet'
    },
    basic: {
      desc:
        'Παρακαλώ, εισαγάγετε το ΑΜΚΑ και το e-mail ή το κινητό σας, για να γίνει η ταυτοποίηση'
    },
    account: {
      desc: 'Παρακαλώ, εισαγάγετε τα προσωπικά σας στοιχεία',
      extraDesc: 'Περαιτέρω οδηγίες, εφόσον χρειαστούν'
    },
    error: {
      generic: 'Λυπούμαστε, υπήρξε κάποιο πρόβλημα!',
      birthdate:
        'Η καταχωρημένη Ημερομηνία γέννησης της ΗΔΙΚΑ είναι λανθασμένη',
      registered: 'Υπάρχει ήδη εγγεγραμμένος χρήστης με ΑΦΜ: %{tin}',
      registrationMail: 'E-mail υπάρχοντος λογαριασμού: %{mail}',
      registrationPhone: 'Κινητό υπάρχοντος λογαριασμού: %{phone}'
    }
  },
  create: 'Δημιουργία λογαριασμού',
  error: {
    age:
      'Για την εγγραφή σας ως Πιστοποιημένος ή Απλός χρήστης, θα πρέπει να έχετε συμπληρώσει τα 15 έτη',
    expired: 'Λήξη συνεδρίας',
    generic: 'Γενικό σφάλμα',
    ssn: {
      invalid: 'Το ΑΜΚΑ δεν είναι έγκυρο',
      notFound: 'Το ΑΜΚΑ δεν βρέθηκε',
      mismatch: {
        mailOrPhone: 'Το ΑΜΚΑ και το e-mail ή το κινητό σας, δεν ταιριάζουν',
        tin: 'Το ΑΜΚΑ και το ΑΦΜ σας, δεν ταιριάζουν'
      },
      registered: 'Το ΑΜΚΑ υπάρχει ήδη'
    },
    mailOrPhone: {
      registered: 'Το e-mail ή το κινητό, υπάρχει ήδη',
      malformed: 'Το e-mail ή το κινητό, δεν είναι έγκυρο'
    },
    pin: 'Λανθασμένο PIN',
    captcha: 'Λανθασμένο Captcha'
  },
  faq: 'Συχνές Ερωτήσεις - Απαντήσεις',
  fathername: 'Πατρώνυμο',
  firstname: 'Όνομα',
  footer: {
    usage: 'Οδηγίες χρήσης',
    info: 'Χρήσιμες πληροφορίες',
    lang: {
      el: 'Ελληνικά – ΕΛ',
      en: 'English – EN'
    },
    copyright:
      '© 2017 Εθνική Βιβλιοθήκη της Ελλάδος. Με επιφύλαξη παντός νομίμου δικαιώματος.'
  },
  header: {
    logo: {
      title: 'Μετάβαση στην αρχική σελίδα Εγγραφής'
    }
  },
  lastname: 'Επώνυμο',
  login: 'Είσοδος',
  mail: 'E-mail',
  next: 'Επόμενο',
  orRegisterAs: 'ή Εγγραφή ως',
  password: {
    original: 'Κωδικός',
    repeat: 'Επιβεβαίωση κωδικού',
    unassigned: 'Απαγορεύονται οι μη-ανατεθειμένοι Unicode χαρακτήρες',
    notAllNums: 'Τουλάχιστον ένας μη αριθμητικός χαρακτήρας',
    similar: 'Απαγορεύεται να προσιδιάζει ο κωδικός στο e-mail ή το κινητό',
    nonAlpha:
      'Τουλάχιστον %{smart_count} ένα αριθμητικό ψηφίο ή ένας μη αλφαβητικός χαρακτήρας |||| Τουλάχιστον %{smart_count} δυο αριθμητικά ψηφία ή δύο μη αλφαβητικοί χαρακτήρες',
    consecutiveNums:
      'Απαγορεύονται περισσότερα από %{smart_count} διαδοχικά νούμερα σε φθίνουσα ή αύξουσα σειρά',
    length:
      'Τουλάχιστον %{smart_count} χαρακτήρας |||| Τουλάχιστον %{smart_count} χαρακτήρες',
    uniq:
      'Τουλάχιστον %{smart_count} μοναδικός χαρακτήρας |||| Τουλάχιστον %{smart_count} μοναδικοί χαρακτήρες'
  },
  phone: 'Κινητό',
  pin: {
    title: 'PIN',
    desc:
      'Παρακαλώ, εισαγάγετε το PIN που λάβατε στο e-mail ή το κινητό σας, για να γίνει η ταυτοποίηση.',
    resend: {
      click: 'Πατήστε',
      here: 'εδώ',
      action: 'για επαναποστολή του PIN σας'
    }
  },
  prefix: 'Πρόθεμα',
  privacyPolicy: 'Πολιτική προστασίας προσωπικών δεδομένων',
  register: 'Εγγραφή',
  ssn: 'ΑΜΚΑ',
  staff: {
    register: 'Εγγραφή προσωπικού',
    basic: {
      desc:
        'Παρακαλώ, εισαγάγετε το ΑΜΚΑ και το e-mail ή το κινητό σας, για να γίνει η ταυτοποίηση'
    },
    account: {
      desc:
        'Επιβεβαιώστε τα παρακάτω στοιχεία και εισαγάγετε τον επιθυμητό, μυστικό κωδικό του λογαριασμού σας',
      extraDesc: 'Περαιτέρω οδηγίες, εφόσον χρειαστούν'
    },
    error: {
      birthdate: 'Η καταχωρημένη Ημερομηνία γέννησης στο HRMS είναι λανθασμένη',
      HRMSPhoneMailNull:
        'Το τηλέφωνο και το εξωτερικό e-mail, δεν έχουν συμπληρωθεί στο HRMS',
      HRMSNoLogin: 'Δεν υπάρχει όνομα σύνδεσης στο HRMS',
      HRMSNoTin: 'Δεν υπάρχει ΑΦΜ στο HRMS'
    }
  },
  success: {
    title: 'Συγχαρητήρια!',
    desc:
      'Έχετε επιτυχώς εγγραφεί στην υπηρεσία. Μπορείτε να συνεχίσετε την πλοήγησή σας πατώντας τα παρακάτω links',
    manage: {
      password: 'Διαχείριση κωδικών',
      account: 'Διαχείριση λογαριασμού'
    }
  },
  taxis: {
    desc:
      'Αν επιθυμείτε να συνδεθείτε με διαφορετικό λογαριασμό στο TAXISnet, θα χρειαστεί να αποσυνδεθείτε και να επαναλάβετε τη διαδικασία εγγραφής από την αρχή',
    logout: 'Αποσύνδεση από TAXISnet'
  },
  tin: 'ΑΦΜ',
  title: 'Εθνική Βιβλιοθήκη της Ελλάδος',
  tooltip: {
    pin: '%{smart_count} ψηφίο |||| %{smart_count} ψηφία',
    year: 'Από %{from} έως %{to}',
    name:
      'Ελληνικά ή Λατινικά. Επιτρέπονται το ενωτικό (-), το κενό, ενώ η απόστροφος, μόνο στα Λατινικά'
  },
  tos: {
    read: 'Έχω διαβάσει και συμφωνώ με όλες τις',
    link: 'Πολιτικές Απορρήτου'
  },
  unload: 'Οι αλλαγές που κάνατε, ενδέχεται να μην έχουν αποθηκευτεί',
  user: {
    title: 'Απλός χρήστης',
    register: 'Εγγραφή Απλού χρήστη',
    desc:
      'Ο Απλός χρήστης λαμβάνει ενημερώσεις, σχετικά με τις υπηρεσίες και τις δραστηριότητες της ΕΒΕ',
    basic: {
      desc:
        'Παρακαλώ, εισαγάγετε το e-mail ή το κινητό σας, για να γίνει η ταυτοποίηση'
    },
    account: {
      desc: 'Παρακαλώ, εισαγάγετε τα προσωπικά σας στοιχεία',
      extraDesc: 'Περαιτέρω οδηγίες, εφόσον χρειαστούν'
    }
  },
  version: 'Έκδοση %{version}'
}
